import { render, staticRenderFns } from "./tusgaizuvshuurul.vue?vue&type=template&id=7fa1f02c&"
import script from "./tusgaizuvshuurul.vue?vue&type=script&lang=js&"
export * from "./tusgaizuvshuurul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports